import type { Brand } from '../types'

/** Anzeigefarbe einer Brand (Primärfarbe, mit neutralem Fallback). */
export function brandColor(brand?: Brand | null): string {
  return brand?.primaryColor || '#8aa0ad'
}

/** Chip-Kürzel: erste Buchstaben der ersten zwei Namensteile (Wort/Bindestrich). */
export function brandInitial(brand?: Brand | null): string {
  const name = brand?.brandName || '?'
  return (
    name
      .split(/[\s-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase() || '?'
  )
}

/** Feste, hübsche BMC-Avatar-Verläufe (Electric-Blue · Teal · Amber). */
const AVATAR_GRADIENTS = [
  'linear-gradient(135deg,#4A6CF7,#7E5BF7)',
  'linear-gradient(135deg,#00D4AA,#0EA5A0)',
  'linear-gradient(135deg,#F5A623,#F0616D)',
  'linear-gradient(135deg,#4A6CF7,#3A57D8)',
  'linear-gradient(135deg,#6B87FF,#00D4AA)',
]

/** Deterministischer Avatar-Verlauf aus einem Seed (z. B. urlKey/Name). */
export function avatarGradient(seed?: string | null): string {
  const s = seed ?? ''
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return AVATAR_GRADIENTS[h % AVATAR_GRADIENTS.length]
}

/** Brand per brandKey finden; liefert einen Platzhalter, falls unbekannt. */
export function brandOf(brands: Brand[], brandKey?: string | null): Brand {
  return (
    brands.find((b) => b.brandKey === brandKey) || {
      brandKey: brandKey || '',
      brandName: brandKey || 'Unbekannt',
    }
  )
}
